<div class="discount-price-container">
  <app-payment-rate-discount
    [calculatedPercentageBytaxes]="true"
    [htmlFormatByCurrency]="true"
    [currencyCode]="price?.CurrencyCode"
    [strikethrough]="price?.Strikethrough"
    [total]="price?.Total"
    [discountAmount]="price?.DiscountAmount"
    [totalDiscount]="price?.TotalDiscount"
    [totalDiscountInStrikethrough]="price?.TotalDiscountInStrikethrough"
    [amount]="price?.Amount"
    [taxes]="price?.Taxes"
    [fees]="price?.Fees"
    [surcharges]="price?.Surcharges">
  </app-payment-rate-discount>
</div>
